import { InspectionsFindingDto } from '../api/types/dtos/inspection';

export const generateFindingsCSV = (findings: InspectionsFindingDto[]): string => {
  // Define headers in Spanish
  const headers = [
    'Criterios',
    'Hallazgos',
    'Análisis',
    'Acción Correctiva',
    'Acción Preventiva'
  ];

  // Start with headers
  const rows = [headers];

  // Add data rows
  findings.forEach(finding => {
    // Get all active criteria numbers with "LM " prefix and newlines
    const criterios = finding.inspectionsFindingsItems
      ?.filter(item => item.isActive)
      .map(item => item.item?.cpNumber ? `LM ${item.item.cpNumber}` : '')
      .filter(Boolean)
      .join('\n');

    const row = [
      criterios || '',
      finding.finding || '',
      finding.analysis || '',
      finding.correctiveAction || '',
      finding.preventiveAction || ''
    ];

    rows.push(row);
  });

  // Convert to CSV format, properly handling commas, quotes, and newlines
  return rows.map(row => 
    row.map(cell => {
      // Always wrap cells in quotes if they contain newlines
      if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
        // Replace any quotes with double quotes (CSV standard)
        return `"${cell.replace(/"/g, '""')}"`;
      }
      return cell;
    }).join(',')
  ).join('\n');
};

export const downloadCSV = (csvContent: string, filename: string) => {
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}; 